import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box, Typography } from '@mui/material';
import { getDefaultAffiliateUserFilter } from '../../interfaces/AffiliateUserSummary/AffiliateUserFilter';
import { PaginatedResponse } from '../../interfaces/PaginatedResponse';
import { AffiliateUserSummary } from '../../interfaces/AffiliateUserSummary/AffiliateUserSummary';
import { getAffiliateUserSummaries } from '../../api/Affiliate';
import { Pagination } from '../../interfaces/Pagination';
import { sharedStyles } from '../../utils/Style';
import { Waiting } from '../../components/Waiting/Waiting';
import { AffiliateUsersTable } from './AffiliateUsersTable';

export const AffiliateUsersPage = () => {
  const [filter, setFilter] = useState(getDefaultAffiliateUserFilter());
  const [loading, setLoading] = useState(false);
  const [affiliateUsers, setAffiliateUsers] = useState<
    PaginatedResponse<AffiliateUserSummary>
  >({
    data: [],
    totalCount: 0,
  });

  const refreshAffiliateUsers = () => {
    setLoading(true);
    getAffiliateUserSummaries(filter)
      .then((res) => setAffiliateUsers(res))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refreshAffiliateUsers();
  }, [filter]);

  const handlePagination = (p: Pagination) => {
    setFilter({ ...filter, pagination: p });
  };

  return (
    <Box sx={{ ...sharedStyles.pageBody }}>
      <Waiting open={loading} />
      <Typography variant='h5' sx={{ ...sharedStyles.pageTitle }}>
        Partner Kullanıcılar
      </Typography>

      <AffiliateUsersTable
        affiliates={affiliateUsers.data}
        totalCount={affiliateUsers.totalCount}
        pagination={filter.pagination}
        onPagination={handlePagination}
      />
    </Box>
  );
};
